import { AccordionHorizontal, calculateAccordionContentWidth, debounce } from './utils/accordionHorizontal.js';

import Tabs       from './components/Tabs.js';
import MobileMenu from './components/MobileMenu.js';

import accordionTimer              from './utils/accordionTimer.js';
import tooltip                     from './utils/tooltip.js';
import accordion                   from './utils/accordion.js';
import newsCategory                from './utils/newsCategory.js';
import { initCatalogFiltersFeature } from './utils/catalog-filters.js';
import circles                     from './utils/circles.js';
import { ingredients }             from './utils/ingredients.js';

// import contacts7 from './utils/contacts7.js';

function initApp() {
    // eslint-disable-next-line no-new
    new MobileMenu();

    tooltip();
    accordion();
    newsCategory();
    initCatalogFiltersFeature();
    circles();
    ingredients();
    accordionTimer();

    const tabContainer = document.querySelector('[data-tabs="tabs"]');
    if (tabContainer) {
        new Tabs(tabContainer);
    }

    const featureAccordion = new AccordionHorizontal({
        wrapperAttr      : 'feature-wrapper',
        triggerAttr      : 'feature-trigger',
        activeClass      : 'is-active',
        groupMode        : true,
        groupAttr        : 'feature-group',
        preventSelfClose : true,
        onOpen           : (wrapper, triggers) => {
            const inner = wrapper.querySelector('.section-according-feature__inner');
            if (inner) {
                const handleTransitionEnd = (event) => {
                    if (event.propertyName.includes('grid-template')) {
                        if (window.innerWidth < 1081) {
                            wrapper.scrollIntoView({
                                behavior : 'smooth',
                                block    : 'start'
                            });
                        }
                        inner.removeEventListener('transitionend', handleTransitionEnd);
                    }
                };
                inner.addEventListener('transitionend', handleTransitionEnd);
            }
        }
    });

    featureAccordion.init();

    // Теперь функции доступны
    calculateAccordionContentWidth();
    window.addEventListener('resize', debounce(calculateAccordionContentWidth, 250));
    document.addEventListener('accordion:change', calculateAccordionContentWidth);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initApp);
} else {
    initApp();
}
